import { render, staticRenderFns } from "./FormOverlay.vue?vue&type=template&id=10c25925&"
import script from "./FormOverlay.vue?vue&type=script&lang=js&"
export * from "./FormOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports